// @flow
import React from "react";
import { Select, MenuItem, TableCell, withStyles } from "@material-ui/core";

const styles = (theme) => ({
  cell: {
    paddingLeft: "8px",
    paddingRight: "8px",
  },
  select: {
    width: "100%",
  },
});

function SelectFilterCell({
  filter,
  onFilter,
  classes,
  selectOptions,
  "data-test": data_test,
}) {
  const onChange = (e) =>
    onFilter(
      e.target.value
        ? {
            value: e.target.value,
          }
        : null
    );

  return (
    <TableCell data-test={data_test} className={classes.cell}>
      <Select
        value={filter ? filter.value : ""}
        onChange={onChange}
        className={classes.select}
      >
        <MenuItem value="">
          <em>Select...</em>
        </MenuItem>
        {selectOptions.map((option, index) => (
          <MenuItem key={index} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </TableCell>
  );
}

export default withStyles(styles, { name: "SelectFilterComponent" })(
  SelectFilterCell
);
